const sanitizeString = (
  dirty: string,
  blackListRegex: RegExp = /<(?:"[^"]*"['"]*|'[^']*'['"]*|[^'">])+>/g
) => dirty.replace(blackListRegex, '');

export default sanitizeString;
